import { dataProps, subItemProps } from './properties'

export const setExpenseCategoryList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setExpenseCategoryData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(subItemProps))]
    } else if(payload.copy) {
        state.props.sub_item_list.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const addNewExpenseSubCategoryItemRow = state => {

    let key = 0
    state.props.sub_item_list.push(JSON.parse(JSON.stringify(subItemProps)))

    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('sub_category_name_'+(key-1)).focus()
    }, 300);

}

export const removeExpenseSubCategoryItemRow = (state, payload) => {

    let key = 0

    state.props.deleted_sub_item_list_items.push(state.props.sub_item_list[payload])

    state.props.sub_item_list.splice(payload, 1)

    if(state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(subItemProps))]
    }

    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetExpenseCategoryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseCategory/mutations.js